import React from 'react';

export default class SuppressingErrorBoundary extends React.Component {
  componentDidCatch() {
    /* swallow error */
  }

  render() {
    const { children } = this.props;

    return children;
  }
}
